import { config } from '../../config/config';
import { AppModeService } from '../common/services/app.mode.service';
var ConfigService = /** @class */ (function () {
    function ConfigService() {
    }
    Object.defineProperty(ConfigService, "config", {
        get: function () {
            return ConfigService._config;
        },
        enumerable: true,
        configurable: true
    });
    ConfigService.prototype.load = function (http) {
        if (!AppModeService.isDevelopmentMode) {
            // return http.get(config.assetImageServeUrl + 'api/config')
            return http.get('https://stagingv2.imgoingcalendar.com/api/config')
                .map(function (res) {
                if (!!res.json) {
                    return res.json();
                }
                return res;
            })
                .do(function (config) {
                console.log(config);
                ConfigService._config = config;
            })
                .toPromise();
        }
        return Promise.resolve(ConfigService._config);
    };
    ConfigService._config = config;
    return ConfigService;
}());
export { ConfigService };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/config.service.ts.pre-build-optimizer.js